import { useEffect, useMemo, useState } from "react";
import {
  Button,
  Card,
  Form,
  Modal,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";

const DEFAULT_IMAGES = [
  "/images/product-1.jpg",
  "/images/logo-icon.png",
];

const ProductImagePicker = ({
  show,
  onHide,
  value,
  onSelect,
}) => {
  const [images, setImages] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [search, setSearch] =
    useState("");

  useEffect(() => {
    if (!show) {
      return;
    }

    const loadImages = async () => {
      setLoading(true);

      try {
        const response = await fetch(
          "/images/restaurant/index.json",
          {
            cache: "no-store",
          }
        );

        if (!response.ok) {
          throw new Error(
            "Image index not found"
          );
        }

        const data =
          await response.json();

        const paths = Array.isArray(
          data
        )
          ? data
          : data?.images || [];

        const normalized =
          paths
            .filter(Boolean)
            .map((path) =>
              path.startsWith("/")
                ? path
                : `/${path}`
            );

        setImages(normalized);
      } catch (error) {
        setImages(
          DEFAULT_IMAGES
        );

        toast.info(
          "فایل index.json تصاویر پیدا نشد؛ فعلاً تصاویر پیش‌فرض نمایش داده می‌شوند."
        );
      } finally {
        setLoading(false);
      }
    };

    loadImages();
  }, [show]);

  const filteredImages =
    useMemo(() => {
      const query =
        search
          .trim()
          .toLowerCase();

      if (!query) {
        return images;
      }

      return images.filter(
        (image) =>
          image
            .toLowerCase()
            .includes(query)
      );
    }, [images, search]);

  const handleSelect = (
    image
  ) => {
    const path =
      image.replace(
        /^\/+/,
        ""
      );

    onSelect(path);
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
    >
      <Modal.Header
        closeButton
      >
        <Modal.Title>
          انتخاب تصویر محصول
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Control
          className="mb-4"
          value={search}
          onChange={(event) =>
            setSearch(
              event.target.value
            )
          }
          placeholder="جستجو در تصاویر..."
          dir="ltr"
        />

        {loading ? (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        ) : filteredImages.length ===
          0 ? (
          <div className="text-center text-muted py-5">
            تصویری پیدا نشد.
          </div>
        ) : (
          <div className="row g-3">
            {filteredImages.map(
              (image) => {
                const imagePath =
                  image.replace(
                    /^\/+/,
                    ""
                  );

                const selected =
                  value ===
                  imagePath;

                return (
                  <div
                    className="col-6 col-sm-4 col-md-3 col-lg-2"
                    key={image}
                  >
                    <Card
                      className={`h-100 ${
                        selected
                          ? "border-primary shadow-sm"
                          : ""
                      }`}
                      style={{
                        cursor:
                          "pointer",
                      }}
                      onClick={() =>
                        handleSelect(
                          image
                        )
                      }
                    >
                      <div
                        className="bg-light d-flex align-items-center justify-content-center"
                        style={{
                          height: 130,
                          overflow:
                            "hidden",
                        }}
                      >
                        <img
                          src={image}
                          alt=""
                          style={{
                            width:
                              "100%",
                            height:
                              "100%",
                            objectFit:
                              "cover",
                          }}
                          onError={(
                            event
                          ) => {
                            event.currentTarget.src =
                              "/images/product-1.jpg";
                          }}
                        />
                      </div>

                      <Card.Body className="p-2">
                        <div
                          className="small text-muted text-break"
                          dir="ltr"
                        >
                          {
                            imagePath
                          }
                        </div>

                        {selected && (
                          <div className="small text-primary fw-bold mt-1">
                            انتخاب شده
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </div>
                );
              }
            )}
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button
          variant="secondary"
          onClick={onHide}
        >
          بستن
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ProductImagePicker;